import {
  MdBusiness,
  MdLocationOn,
  MdSportsTennis,
  MdPayment,
  MdFitnessCenter,
  MdEvent,
  MdCardMembership,
  MdStorefront,
  MdLocalOffer,
} from 'react-icons/md';
import { IconType } from 'react-icons';

export type ChecklistItemId =
  | 'create_organization'
  | 'add_location'
  | 'setup_courts'
  | 'connect_stripe'
  | 'add_coaches'
  | 'create_event'
  | 'create_membership'
  | 'create_product'
  | 'create_coupons';

export type ChecklistItemDef = {
  id: ChecklistItemId;
  icon: IconType;
  /** Route to navigate to when the user clicks "Go" */
  route: string;
  /** Whether completion is auto-detected (true) or manually toggled (false) */
  autoDetect: boolean;
};

export const CHECKLIST_ITEMS: ChecklistItemDef[] = [
  { id: 'create_organization', icon: MdBusiness,        route: '/admin/organization', autoDetect: true },
  { id: 'add_location',        icon: MdLocationOn,      route: '/admin/locations',    autoDetect: true },
  { id: 'setup_courts',        icon: MdSportsTennis,    route: '/admin/courts',       autoDetect: true },
  { id: 'connect_stripe',      icon: MdPayment,         route: '/admin/organization', autoDetect: true },
  { id: 'add_coaches',         icon: MdFitnessCenter,   route: '/admin/coachs',       autoDetect: true },
  { id: 'create_event',        icon: MdEvent,            route: '/admin/events',       autoDetect: true },
  { id: 'create_membership',   icon: MdCardMembership,  route: '/admin/memberships',  autoDetect: false },
  { id: 'create_product',      icon: MdStorefront,      route: '/admin/products',     autoDetect: false },
  { id: 'create_coupons',     icon: MdLocalOffer,      route: '/admin/coupons',      autoDetect: false },
];

export const STORAGE_PREFIX = 'walkthrough';
